export const RESTAURANT_INVENTORY_UPDATED_EVENT =
  'restaurant-inventory-updated';

export const notifyRestaurantInventoryUpdated = () => {
  window.dispatchEvent(new CustomEvent(RESTAURANT_INVENTORY_UPDATED_EVENT));
};
